import React from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

/**
 * Wrapper for JE/Aware switch using MUI
 * @param {boolean} value
 * @param {function(boolean)} setValue
 * @returns {Element}
 */
export function JE_AwareSwitch({ value, setValue }) {
    return (
        <FormControlLabel
            control={
                <Switch
                    checked={value}
                    onChange={(_, checked) => setValue(checked)}
                    color="primary"
                />
            }
            label={value ? 'JE' : 'Aware'}
        />
    );
}